import React, { useCallback, useEffect, useState } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import useAuthFetch from "../../hooks/useAuthFetch";
import Pagination from "../../components/Pagination";
import Spinner from "../../components/Spinner";
import { useSelector } from "react-redux";

const CatalogsPage = () => {
  const [catalogos, setcatalogos] = useState(null);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const { token } = useSelector((store) => store.app.user);
  const authFetch = useAuthFetch();

  const fetchcatalogos = useCallback(async () => {
    const pageSize = 5;
    setLoading(true);

    const catalogoFetch = await authFetch(
      `catalogos?filter={
			"limit": ${pageSize},
			"skip": ${page * pageSize},
			"where":{"and":[{"idCatalogo": null},{"activo": 1}]},
			"order": ["createdAt DESC"]}`
    );
    const catalogosData = await catalogoFetch.json();
    setcatalogos(catalogosData);
    const totalCatalogoFetch = await authFetch(
      `catalogos/count?where={"and":[{"idCatalogo": null},{"activo": 1}]}`
    );
    const totalCatalogoData = await totalCatalogoFetch.json();
    setTotalPages(Math.ceil(totalCatalogoData.count / pageSize));
    setTotalCount(totalCatalogoData.count);
    setLoading(false);
  }, [page]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchcatalogos();
  }, [fetchcatalogos]);

  const fetchDeleteCatalogo = async (id) => {
    const catalogoFetch = await authFetch(
      `catalogos/${id}`,
      {
        activo: 0,
      },
      "DELETE",
      token
    );
    if (
      catalogoFetch.status === 200 ||
      catalogoFetch.status === 201 ||
      catalogoFetch.status === 204
    ) {
      Swal.fire({
        icon: "success",
        title: "¡Correcto!",
        text: "Catálogo inactivado correctamente",
        background: "#76236C",
        color: "#fafafa",
        confirmButtonColor: "#19D3C5",
      });
      fetchcatalogos();
    }
    if (
      catalogoFetch.status === 400 ||
      catalogoFetch.status === 401 ||
      catalogoFetch.status === 404 ||
      catalogoFetch.status === 500
    ) {
      Swal.fire({
        icon: "error",
        title: "¡Error!",
        text: "Error al inactivar un catálogo",
        background: "#76236C",
        color: "#fafafa",
        confirmButtonColor: "#19D3C5",
      });
    }
  };

  const deleteCatalogo = async (id) => {
    Swal.fire({
      title: "¿Estas seguro que deseas inactivar este catálogo?",
      text: "Una vez realizada la acción no podrás revertirla",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, inactivar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#19D3C5",
      cancelButtonColor: "#E7004C",
      background: "#76236C",
      color: "#fafafa",
    }).then((result) => {
      if (result.isConfirmed) {
        fetchDeleteCatalogo(id);
        fetchcatalogos();
        setPage(0);
      }
    });
  };

  return (
    <div className="w-full p-content pb-16">
      {loading && <Spinner />}
      <div>
        <div className="flex w-full items-center">
          <div className="w-full flex justify-between">
            <div>
              <p className="text-2xl font-bold mb-4">
                Catálogos (Total: {totalCount})
              </p>

              <Link to={`/catalogos/${"padre"}`}>
                <button className="bg-cyan text-white py-2 px-6 font-bold rounded-full flex justify-center items-center">
                  {"+"} Nuevo catálogo
                </button>
              </Link>
            </div>

            <Link to="/inventario">
              <button className="bg-pink text-white py-2 px-8 font-bold rounded-full float-right flex justify-center items-center">
                <IoMdArrowRoundBack className="text-lg" /> Volver
              </button>
            </Link>
          </div>
        </div>
        <br />

        {catalogos && catalogos.length > 0 ? (
          <>
            <Pagination
              totalPages={totalPages}
              currentPage={page}
              onPageChange={(page) => {
                setPage(page);
              }}
            />

            {catalogos.map((c, index) => (
              <div
                className="w-full ring-1 ring-purple rounded-lg mb-4 p-6"
                key={index}
              >
                <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                  <div>
                    <br />
                    <p className="text-2xl">{c.valor}</p>
                  </div>
                  <div className="flex w-full justify-end mt-6">
                    <Link
                      to={`/catalogos/valores/${c.id}`}
                      className="rounded-3xl py-2 px-8 my-1 font-medium text-white bg-cyan mx-3"
                    >
                      Ver valores
                    </Link>
                    <Link
                      to={`/catalogos/${c.id}`}
                      className="rounded-3xl py-2 px-8 my-1 font-medium text-white bg-purple"
                    >
                      Editar
                    </Link>
                    <button
                      className="rounded-3xl py-2 px-8 ml-2 my-1 font-medium text-white bg-pink"
                      onClick={() => deleteCatalogo(c.id)}
                    >
                      Inactivar
                    </button>
                  </div>
                </div>
              </div>
            ))}
            <Pagination
              totalPages={totalPages}
              currentPage={page}
              onPageChange={(page) => {
                setPage(page);
              }}
            />
          </>
        ) : (
          !loading && <p>No hay catálogos para mostrar</p>
        )}
      </div>
    </div>
  );
};

export default CatalogsPage;
